import { getEnvVar } from "../utils.js";
class EvalsClient {
    baseUrl;
    constructor(baseUrl = ''){
        this.baseUrl = baseUrl;
    }
    getHeaders() {
        const headers = {
            'Content-Type': 'application/json'
        };
        if (this.baseUrl) {
            const token = getEnvVar('CHRONOSPHERE_API_TOKEN', {
                required: false
            });
            if (token) headers['API-Token'] = token;
        }
        return headers;
    }
    async scoreFeature(req) {
        const response = await fetch(`${this.baseUrl}/api/evals/score`, {
            method: 'POST',
            headers: this.getHeaders(),
            body: JSON.stringify(req)
        });
        if (!response.ok) {
            const text = await response.text();
            throw new Error(`Evals backend request failed: ${response.status} ${response.statusText}. Response: ${text}`);
        }
        const data = await response.json();
        if (!data) throw new Error('Evals backend returned empty response');
        return data;
    }
    async recordEval(req) {
        const response = await fetch(`${this.baseUrl}/api/evals/record`, {
            method: 'POST',
            headers: this.getHeaders(),
            body: JSON.stringify(req)
        });
        if (!response.ok) {
            const text = await response.text();
            throw new Error(`Evals backend request failed: ${response.status} ${response.statusText}. Response: ${text}`);
        }
        const data = await response.json();
        if (!data) throw new Error('Evals backend returned empty response');
        return data;
    }
}
export { EvalsClient };

//# sourceMappingURL=evals-client.js.map